var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1014_1768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.85059 14.7684L2.38066 16.8895C2.47297 17.2589 2.68609 17.5867 2.98612 17.821C3.28616 18.0554 3.6559 18.1827 4.03659 18.1827H16.7361C17.1168 18.1827 17.4865 18.0554 17.7865 17.821C18.0866 17.5867 18.2997 17.2589 18.392 16.8895L18.9221 14.7684M10.3863 13.0613V2.81836V13.0613ZM10.3863 13.0613L6.97204 9.64696L10.3863 13.0613ZM10.3863 13.0613L13.8006 9.64696L10.3863 13.0613Z",
    stroke: "#5FB4D9",
    strokeWidth: 1.70715,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1014_1768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4858,
    height: 20.4858,
    fill: "white",
    transform: "translate(0.143066 0.257812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.03018069d34ab74a11403e5665445aea.svg";
export { ForwardRef as ReactComponent };